<div
  class="wallet-partner-banner"
  (click)="$event.stopPropagation()"
  *ngIf="(isMobile$ | async) === false && getWalletDetails(walletProvider)"
  [style.background-color]="getWalletDetails(walletProvider)?.colorPalette"
>
  <div
    class="inner-container"
    [ngStyle]="{
      'justify-content':
        stepper?.selectedIndex! > 0 && showBackIcon
          ? 'space-between'
          : 'flex-end'
    }"
  >
    <div
      class="chevron_left-btn"
      *ngIf="stepper?.selectedIndex! > 0 && showBackIcon"
      (click)="onBack()"
    >
      <img
        src="assets\images\arr-chevron-left.svg"
        [style.color]="getWalletDetails(walletProvider)?.chevronBtnColor"
        class="chevron_left_icon"
        alt=""
      />
    </div>

    <div class="log-logo-container">
      <a
        [href]="getWalletDetails(walletProvider)?.webUrl"
        class="companyWebUrl"
        target="_blank"
      >
        <img
          class="companyLogo"
          [ngClass]="{
            'white-bit': walletProvider.toUpperCase() === 'WHITEBIT'
          }"
          [src]="getWalletDetails(walletProvider)?.companyLogUrl"
          [alt]="walletProvider"
        />
      </a>
    </div>
  </div>
</div>

<div
  class="wallet-partner-banner"
  (click)="$event.stopPropagation()"
  *ngIf="
    (isMobile$ | async) === false &&
    !getWalletDetails(walletProvider) &&
    stepper?.selectedIndex! > 0
  "
>
  <div
    class="inner-container"
    [ngStyle]="{
      'justify-content':
        stepper?.selectedIndex! > 0 && showBackIcon
          ? 'space-between'
          : 'flex-end'
    }"
  >
    <div
      class="chevron_left-btn"
      *ngIf="stepper?.selectedIndex! > 0 && showBackIcon"
      (click)="onBack()"
    >
      <img
        src="assets\images\arr-chevron-left.svg"
        class="chevron_left_icon"
        [style.color]="getWalletDetails(walletProvider)?.chevronBtnColor"
        alt=""
      />
    </div>
    <div *ngIf="getWalletDetails(walletProvider)" class="log-logo-container">
      <a
        [href]="getWalletDetails(walletProvider)?.webUrl"
        class="companyWebUrl"
        target="_blank"
      >
        <img
          class="companyLogo"
          [ngClass]="{
            'white-bit': walletProvider.toUpperCase() === 'WHITEBIT'
          }"
          [src]="getWalletDetails(walletProvider)?.companyLogUrl"
          [alt]="walletProvider"
        />
      </a>
    </div>
  </div>
</div>
